export const textCss =
  'font-size: 24px; line-height: 31px; font-weight: 300; margin-top: 0; text-align: center;';
